import { useGetSocketToken } from '@/hooks/use-web-socket/use-get-socket-token';
import { useWindowKeeper } from '@/hooks/useWindowKeeper';
import { removeFromLocalStorage } from '@/lib/local-storage/local-storage';
import { useQueryClient } from '@tanstack/react-query';
import { SESSION_KEY } from '../constants';
import { closeSocket } from '@/hooks/use-web-socket/utils';

export function useSignOut() {
  const queryClient = useQueryClient();
  const socketToken = useGetSocketToken();
  const { resetPreviews } = useWindowKeeper();
  return () => {
    removeFromLocalStorage({ key: SESSION_KEY });
    if (socketToken) {
      closeSocket(socketToken);
    }
    resetPreviews();
    queryClient.cancelQueries();
    queryClient.clear();
    window.location.href = '/login';
  };
}
